import { Route } from '@angular/router';
import { ROUTER_PATHS } from './app.const';
import { manualUrlNavigationGuard } from './core/guards/manual-url-navigation.guard';
import { contactUsNavigationGuard } from './core/guards/contact-us-navigation.guard';
import { canDeactivateForwardNavigationGuard } from './core/guards/forward-navigation.guard';
import { secureCheckoutNavigationGuard } from './core/guards/secure-checkout-navigation.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivateChild: [contactUsNavigationGuard],
    canActivate: [contactUsNavigationGuard],
    children: [
      {
        path: 'playground',
        loadComponent: () => import('./components/playground/playground.component').then((c) => c.PlaygroundComponent)
      },
      {
        path: ROUTER_PATHS.TRIP_DETAILS,
        loadComponent: () => import('./pages/trip-details/trip-details.component').then((c) => c.TripDetailsComponent),
        canActivate: [manualUrlNavigationGuard],
        canDeactivate: [canDeactivateForwardNavigationGuard, secureCheckoutNavigationGuard]
      },
      {
        path: ROUTER_PATHS.COVER_OPTIONS,
        loadComponent: () => import('./pages/covers-page/covers-page.component').then((c) => c.CoversPageComponent),
        canMatch: [],
        canActivate: [manualUrlNavigationGuard],
        canDeactivate: [secureCheckoutNavigationGuard, canDeactivateForwardNavigationGuard]
      },
      {
        path: ROUTER_PATHS.TRAVELER_DETAILS,
        loadComponent: () =>
          import('./pages/traveller-details/traveller-details.component').then((c) => c.TravellerDetailsComponent),
        canActivate: [manualUrlNavigationGuard],
        canDeactivate: [canDeactivateForwardNavigationGuard]
      },
      {
        path: ROUTER_PATHS.SECURE_CHECKOUT,
        loadComponent: () =>
          import('./pages/secure-checkout/security-checkout.component').then((c) => c.SecurityCheckoutComponent),
        canMatch: [],
        canActivate: [manualUrlNavigationGuard],
        canDeactivate: [canDeactivateForwardNavigationGuard]
      },
      {
        path: ROUTER_PATHS.SUCCESS_PAGE,
        loadComponent: () => import('./pages/success-page/success-page.component').then((c) => c.SuccessPageComponent),
        canActivate: [manualUrlNavigationGuard]
      },
      {
        path: ROUTER_PATHS.BILLING_SUCCESS,
        loadComponent: () =>
          import('./pages/secure-checkout/payment-success/payment-success.component').then(
            (c) => c.PaymentSuccessComponent
          )
      },
      {
        path: ROUTER_PATHS.BILLING_ERROR,
        loadComponent: () =>
          import('./pages/secure-checkout/payment-error/payment-error.component').then((c) => c.PaymentErrorComponent)
      },
      {
        path: ROUTER_PATHS.UNDER_CONSTRUCTION,
        loadComponent: () => import('@pc/under-construction').then((c) => c.UnderConstructionComponent),
        canActivate: [manualUrlNavigationGuard],
        canDeactivate: [secureCheckoutNavigationGuard]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ROUTER_PATHS.TRIP_DETAILS
      },
      {
        path: '**',
        redirectTo: ROUTER_PATHS.TRIP_DETAILS
      }
    ]
  }
];
